import(/* webpackMode: "eager" */ "/vercel/path0/app/search/page.tsx");
